import { render, staticRenderFns } from "./PdpDefaultV1.vue?vue&type=template&id=0c6dcef8&scoped=true"
import script from "./PdpDefaultV1.vue?vue&type=script&lang=js"
export * from "./PdpDefaultV1.vue?vue&type=script&lang=js"
import style0 from "./PdpDefaultV1.vue?vue&type=style&index=0&id=0c6dcef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6dcef8",
  null
  
)

export default component.exports